import { ITaskState } from "./types";
import { TASK_ACTIONS, actions } from "./actions";
import { TASK_MUTATIONS, mutations } from "./mutations";
import { IRootState } from "../types";
import { Module } from "vuex";
import { cloneDeep } from "@/helpers/object";

export const state: ITaskState = {
  isLoading: false,
  applicationTimeline: []
};

export namespace TASK {
  export const ACTIONS = TASK_ACTIONS;
  export const MUTATIONS = TASK_MUTATIONS;
  export const NAME_SPACE = "tasks";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const task: Module<ITaskState, IRootState> = {
  namespaced,
  state: cloneDeep(state), // create a deep clone of state object so we can reuse the state object
  actions,
  mutations
};
